import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const PRODUCT_INFO: ComboBoxItem<string>[] = [
  {
    id: 0,
    label: "Deals with confidential information",
    value: "Deals with confidential information",
  },
  {
    id: 1,
    label: "Directly used on financial transactions",
    value: "Directly used on financial transactions",
  },
  {
    id: 2,
    label:
      "Deals with high-risk situation (e.g. Lack of accuracy and timeliness in the AI may lead to the loss of life)",
    value: "Deals with high-risk situation",
  },
  {
    id: 3,
    label: "It is critical for the AI Response Time to be less than 1s",
    value: "It is critical for the AI Response Time to be less than 1s",
  },
];

export default PRODUCT_INFO;
